import React from 'react'
import { useSelector } from 'react-redux'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'

import { ROLES } from '../common/constants/appConstants'
import { hasRole } from '../common/utils/utils'
import { getAuthRoles } from '../data/auth/authSelectors'
import MyProviderInfo from '../myInfo/individualProvider/MyProviderInfo'
import MyPracticeInfo from '../myInfo/practicesAdmin/MyPracticeInfo'

const MyInfoRoutes: React.FC = () => {
  const roles = useSelector(getAuthRoles)

  const getContent = () => {
    if (hasRole(roles, ROLES.PRACTICES_ADMIN)) {
      return <MyPracticeInfo />
    } else if (hasRole(roles, [ROLES.INDIVIDUAL_PROVIDER, ROLES.PRACTICE_PROVIDER])) {
      return <MyProviderInfo />
    } else {
      return <h1>MYINFO_DASHBOARD, default</h1>
    }
  }

  return (
    <div>
      <ContentLayout>{getContent()}</ContentLayout>
    </div>
  )
}

export default MyInfoRoutes
